import { routerOutlet } from 'core/modules/router-outlet';

// router configuration
import { routes } from './router.config';

/**
 * @ignore
 */
export const RouterOutlet = routerOutlet( routes );

